import { ReactNode } from 'react';

export enum Placement {
  NONE = 0,
  DROPDOWN = 1,
  NAVBAR = 2,
}

export type RouteFeatureToggle = {
  name: string;
  type: string;
};

export type NavigationRoute = {
  component: ReactNode;
  label: string;
  path: string;
  claim: string;
  placement: Placement;
  to: string;
  exact?: boolean;
  hideFooter?: true;
  featureToggle?: RouteFeatureToggle;
};

export type NavigationAction = {
  type: 'setMain' | 'setDropdown';
  body: NavigationRoute[];
};

export type NavigationState = {
  main: NavigationRoute[];
  dropdown: NavigationRoute[];
};

const INITIAL_STATE: NavigationState = {
  main: [],
  dropdown: [],
};

export const setMainNav = (nav: NavigationRoute[]): NavigationAction => {
  return {
    type: 'setMain',
    body: nav,
  };
};

export const setDropdownNav = (nav: NavigationRoute[]): NavigationAction => {
  return {
    type: 'setDropdown',
    body: nav,
  };
};

type NavReducer = (state: NavigationState, action: NavigationAction) => NavigationState;

const reducer: NavReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'setMain':
      return { ...state, main: action.body };
    case 'setDropdown':
      return { ...state, dropdown: action.body };
    default:
      return state;
  }
};

export default reducer;
